import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    HostListener,
    Inject,
    Input,
    LOCALE_ID,
    OnInit,
    ViewChild
} from '@angular/core';
import {slideInAnimation} from "../../route-animation";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";
import {ConfirmationService, MenuItem, MenuItemCommandEvent, MessageService} from "primeng/api";
import {MenuBarComponent} from "../component/menu-bar/menu-bar.component";
import {TopBarComponent} from "../component/top-bar/top-bar.component";
import {FooterComponent} from "../component/footer/footer.component";
import {PerformanceSectionComponent} from "../component/performance-section/performance-section.component";
import {RestBackendService} from "../../services/rest-backend.service";
import {GlobalService} from "../../services/global.service";
import {Setting} from "../../dto/Setting";
import {ConfigService} from "../../services/config.service";
import {Pages} from "../../dto/Pages";
import {locale} from "moment";
import {NgIf} from "@angular/common";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ProgressBarModule} from "primeng/progressbar";
import {ToastModule} from "primeng/toast";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-template',
    standalone: true,
    imports: [
        RouterOutlet,
        MenuBarComponent,
        TopBarComponent,
        FooterComponent,
        PerformanceSectionComponent,
        NgIf,
        ConfirmDialogModule,
        ProgressBarModule,
        ToastModule
    ],
    templateUrl: './template.component.html',
    styleUrl: './template.component.css',
    animations: [
        slideInAnimation
    ]
})
export class TemplateComponent implements OnInit {

    topLoad: boolean = false;
    static width: number;
    sidbarStyle: boolean = true;

    itemsMainMenu: MenuItem[] | undefined;
    perform: any;
    top_bar: any = {};
    top_bar_Link: Pages;
    itemsTopBar: MenuItem[] | undefined;
    dashboardInfo: any;
    @ViewChild("menubar") menubar: MenuBarComponent;
    loadMenu: boolean = false;



    constructor(
        public restBack: RestBackendService,
        public route: Router,
        public global: GlobalService,
        public config: ConfigService,
        private metaService: Meta,
        public activeRoute: ActivatedRoute,
        protected messageService: MessageService,
        protected confirmationService: ConfirmationService,
        protected meta: Meta,
        @Inject(LOCALE_ID) public locale: string,
        public cdr: ChangeDetectorRef,
        public titleService:Title
    ) {
    }

    ngAfterContentInit(): void {

        document.body.onscroll = function (event) {
            let navbar = document.getElementById("header");
            let center = document.getElementById("center");
            let sticky = navbar.offsetTop;
            // @ts-ignore
            if (event.target.scrollTop > sticky) {
                navbar.classList.add("sticky-header")
                center.classList.add("sticky-center")
            } else {
                navbar.classList.remove("sticky-header");
                center.classList.remove("sticky-center");

            }

            //........................sideMenu..........................
            let side = document.getElementById("side-index");
            if (side != null && side.offsetTop != null) {
                let sideSticky = side.offsetTop;
                var success_body = document.querySelector<HTMLElement>(".success-body");
                let succBodyTop = success_body.offsetTop;
                var side_div = document.querySelector<HTMLElement>("#side-index>div");
                let sidheight = side_div.offsetHeight;
                let succBodyBottom = success_body.offsetTop + success_body.offsetHeight - sidheight - 80;
                let offset=20;
                if (window.location.pathname.indexOf("success_story") > 0) {
                    offset= success_body.offsetTop;
                }
                let pageW = document.body.offsetWidth
                if (pageW > 740) {
                    // @ts-ignore
                    side_div.style.top =  (succBodyTop<offset ? offset : succBodyTop) + "px";
                } else {
                    side_div.style.top = "auto";
                }
                // @ts-ignore
                // if (event.target.scrollTop  > 20) {
                    side.classList.add("side-sticky");
                    // side_div.style.display = "";
                    if (pageW > 740) {
                        // @ts-ignore
                        side_div.style.top = (event.target.scrollTop<offset ? offset : event.target.scrollTop) + "px";
                        side_div.style.position = "absolute"
                    } else {
                        side_div.style.position = "relative"
                    }
                    // side.classList.add("fixed");
                // }
                // @ts-ignore
                if (event.target.scrollTop < succBodyTop) {
                    side.classList.remove("side-sticky");
                }
                // @ts-ignore
                else if (event.target.scrollTop > succBodyBottom) {
                    side.classList.remove("side-sticky");
                    side_div.style.position = "relative"
                    side_div.style.top = "0px";


                }
            }

        };
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode;
        if (keyPressed === 119) {
            debugger;
        }
    }


    ngOnInit(): void {

        let mmnu = [];
        let topmnu = [];

        this.itemsMainMenu = []
        this.itemsTopBar = []
        setTimeout(()=>{
            this.loadMainData().add(() => {
                try {
                    this.top_bar = JSON.parse(this.global.getMainData()['main-page']['data'])['top-bar'];
                } catch (e) {
                }
                try {
                    topmnu = JSON.parse(this.global.getMainData()['top-menu']['data']);
                } catch (e) {
                }
                try {
                    mmnu = JSON.parse(this.global.getMainData()['menu']['data']);
                } catch (e) {
                }
                try {
                    this.perform = JSON.parse(this.global.getMainData()['main-page']['data'])['performance-bar'];
                } catch (e) {
                }
                try {
                    this.dashboardInfo = JSON.parse(this.global.getMainData()['dashboard']['data']);
                } catch (e) {
                }
                setTimeout(() => {
                    try {
                        this.top_bar = JSON.parse(this.global.getMainData()['main-page']['data'])['top-bar'];
                    } catch (e) {
                    }
                    try {
                        topmnu = JSON.parse(this.global.getMainData()['top-menu']['data']);
                    } catch (e) {
                    }
                    try {
                        this.top_bar_Link = JSON.parse(this.global.getMainData()['main-page']['data'])['top-bar']['page'];
                    } catch (e) {
                    }
                    try {
                        mmnu = JSON.parse(this.global.getMainData()['menu']['data']);
                    } catch (e) {
                    }
                    try {
                        this.perform = JSON.parse(this.global.getMainData()['main-page']['data'])['performance-bar'];
                    } catch (e) {
                    }
                    try {
                        this.dashboardInfo = JSON.parse(this.global.getMainData()['dashboard']['data']);
                    } catch (e) {
                    }

                    this.menuGenerator(topmnu, {}, this.itemsTopBar);
                    this.menuGenerator(mmnu, {}, this.itemsMainMenu);
                    setTimeout(() => {
                        this.loadMenu = true;
                    }, 20)


                }, 500)

            });
        },0)


    }


    loadMainData() {
        if (!this.global.loadedMain) {
            this.global.loadedMain = true
            this.global.progressBar = true;
            var observable = this.restBack.doGet("lnd/site/mainpage?");
            return observable.subscribe({
                next: (res: string) => {
                    if (res["status"] == 200) {
                        this.global.setCluster(res["cluster"]);
                        let tempData: Map<string, Setting> = res["entity"];
                        this.global.setMainData(tempData);
                        setTimeout(() => {
                            this.global.loadedMain = false;
                        }, 3000);


                    }
                    return res;
                },
                error: (e) => {
                    this.messageService.clear();
                    this.messageService.add({
                            severity: 'error',
                            summary: $localize`:@@Error:Error`,
                            detail: $localize`:@@Server Timout Det:Server Timout Det`
                        }
                    );
                },
                complete: () => {
                    this.topLoad = true;
                    this.global.progressBar = false;
                    this.cdr.detectChanges()
                }
            });

        } else {
            return new Subscription();
        }

    }


    //......................................................................

    @HostListener('window:scroll', [])
    onWindowScroll() {

    }

    @HostListener('window:touchStart', ['$event']) checkTouchEnd(event) {
        let start = event.changedTouches[0];
    }

    getDirection(): string {
        if (this.locale == "fa") {
            return "rtl";
        } else {
            return "ltr";
        }
    }

    responsiveCloseMenu() {
        if (TemplateComponent.width < 800) {
            this.sidbarStyle = false;
        }
    }

    onscroll(event, topElementName) {
        let navbar = document.getElementById(topElementName);
        let sticky = navbar.offsetTop;
        // console.log(event.target.scrollTop +"-"+ sticky)
        if (event.target.scrollTop >= sticky) {
            navbar.classList.add("sticky")
        } else {
            navbar.classList.remove("sticky");
        }
        // document.querySelector("."+topElementName) as HTMLElement;
        // let navbar2 = document.getElementById(topElementName);
        // let sticky2 = navbar2.offsetTop;
        // // console.log(event.target.scrollTop +"-"+ sticky)
        // if (event.target.scrollTop >= sticky2) {
        //     navbar2.classList.add("sticky")
        // } else {
        //     navbar2.classList.remove("sticky");
        // }
    }

    menuGenerator(menuItemsData: MenuItem[], parent: MenuItem, menu: MenuItem[]) {
        try {
            for (let menuItem of menuItemsData) {
                let iconStyle = {}
                let icon = null;
                if (menuItem.icon != null && menuItem.icon.length > 5) {
                    iconStyle = {
                        "background-image": "url(" + menuItem.icon + ")",
                    }
                    icon = "-";

                } else if (JSON.stringify(parent) == '{}')
                    icon = null;
                let item = {
                    label: menuItem.label,
                    url: menuItem.url != null && menuItem.url.length > 5 ? menuItem.url : null,
                    command: (e) => {
                        if (menuItem.routerLink != null && menuItem.routerLink.length > 0) {
                            this.route.navigateByUrl("/").finally(() => {
                                this.route.navigate([menuItem.routerLink]);
                            })
                        }
                    },
                    items: [],
                    icon: icon,
                    iconStyle: iconStyle,
                    iconUrl:menuItem.icon
                }
                if (menuItem.items != null && menuItem.items.length > 0) {
                    this.menuGenerator(menuItem.items, item, item.items);
                }
                menu.push(item);

            }
        } catch (e) {
            console.log(e);
        }

    }


}
